import { RothermelAccountIntelligenceView } from "./RothermelAccountIntelligenceView";

const ARTIFACT_RENDERERS = {
  "termin-zusammenfassung": RothermelAccountIntelligenceView
};

export function resolveArtifactRenderer({ type, contentFormat }) {
  if (contentFormat !== "blocks") {
    return null;
  }

  return ARTIFACT_RENDERERS[type] || null;
}

export { RothermelAccountIntelligenceView };
